import DocumentsButtons from "../../../ui/documents-buttons";
import { DocumentsProps } from "./types";
import Space from "antd/lib/space";
import { SubSessionProvider } from "../../../../contexts/session-sub/index.context";
import SubTable from "./table";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";

//Components


//UI



export default function Documents(props: DocumentsProps) {
  const location = useLocation();
  const nameSub = "sub_"; // Укажите значение nameSub
  
  
  const isElectronicMailOfDocuments =
      (props.url || location.pathname) === "/documents/electronic-mail";
  const getSubTableUrl = (url?: string) => {
    var subTableUrl = url
    if (isElectronicMailOfDocuments) subTableUrl +="/getfiles";
    return subTableUrl;
  };
  
  const subTableUrl = getSubTableUrl(props.url || location.pathname);

  return (
    <SubSessionProvider url={props.url} nameSub={nameSub}>
     {(props.url || location.pathname) === "/documents/electronic-mail" &&  
     <Space direction="vertical" style={{ marginTop: "0", height: "100%"}} className="subTableStyle">
          <DocumentsButtons url={subTableUrl} /><SubTable showPagination={false} url={subTableUrl} name={nameSub} /></Space>}
    </SubSessionProvider>
  );
}
